<div>
  <h4 class="mb-md flex items-center">
    @if (icon) {
      <span class="w-12 text-center">
        <fa-icon [icon]="icon" class="text-gold-500" size="lg"></fa-icon>
      </span>
    }
    <span [class.ml-xs]="icon">{{ title }}</span>
  </h4>
  <span class="font-normal">{{ description }}</span>
</div>
